module.exports = {

  init() {

    lozad().observe();
    
    this.cookie();
    
    this.homeSlider();
      
    //this.mobileMenuToggle();
    
    this.pageOffset()
    
    this.fixedMenu()

  },

  
  cookie() {
	  $(document).ready(function(){
	    $.cookieBar({
			message: "This website uses cookies to ensure you get the best experience on our website. For more information visit our <a href='/privacy-policy'>Privacy & Cookie Policy</a>.",
			acceptText: "I'm happy with that",
			fixed: true,
			policyButton: false,
			policyText: "Find out more",
			policyURL: "/privacy-policy"
		});
	  });  
	
  },
  
  homeSlider() {
  	const swiper = new Swiper('.home-slider-container', {
  	  // Optional parameters
  	  direction: 'horizontal',
  	  loop: true,
  	  speed: 400,
  	  slidesPerView: 1,
  	  spaceBetween: 80,
  	  // Responsive breakpoints
  	  autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
  	
  	 // If we need pagination
  	  pagination: {
  	    el: '.swiper-home-pagination',
  	    clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
  	  },
  	
  	  // Navigation arrows
  	  navigation: {
  	    nextEl: '.swiper-button-home-next',
  	    prevEl: '.swiper-button-home-prev',
  	  },
  	
  	 
  	});

  },
  
  
  pageOffset(){
    
    function pageOffsetFunction() {
    
      var headerHeight = $("#masthead").height();
      //console.log(headerHeight);
      $('#main').css('margin-top', headerHeight);
    
    }
    
    $(document).ready(pageOffsetFunction);
	  $(window).on('resize',pageOffsetFunction);
    
  },
  
  fixedMenu() {

  	window.onscroll = function() {myFunction()};
  
  	var header = document.getElementById("masthead");
  	var navbar = document.getElementById("navbar");
  	var sticky = navbar.offsetTop;
  	var body = document.body;
  
  	
  	function myFunction() {
  	  if (window.pageYOffset > sticky) {
  	    header.classList.add("sticky");
  	    body.classList.add("sticky");
  	  } else {
  	    header.classList.remove("sticky");
  	    body.classList.remove("sticky");
  	  }
  	  
  	}

  },
  
  mobileMenuToggle() {
	  
	  function myfunction() {

		  var width = $(window).width();
		  

		  if(width < 992){  			  
			
			$('.menu-item-has-children a.dropdown-toggle[href="#"]').on('click', function(e) {  	
				e.preventDefault(); 
				$(this).next('.dropdown-menu').toggleClass('show');	
			});
			
			$('.menu-item-has-children a.dropdown-toggle[href!="#"] span').on('click', function(e) { 	
				e.preventDefault(); 
				$(this).parent().next('.dropdown-menu').toggleClass('show');	
			});
			
		  } else {
			  
			  $('.menu-item-has-children .dropdown-menu').removeClass('show');
			  
			  $('.menu-item-has-children a.dropdown-toggle[href="#"]').on('click', function(e) {  	
				e.preventDefault(); 
			  });
			  
		  }

	  }
	  
	  $(document).ready(myfunction);
	  $(window).on('resize',myfunction);
	  
	 
  },
  
  


}
